import { render, staticRenderFns } from "./gaokaobaike_mobile.vue?vue&type=template&id=6ff0123f&scoped=true"
import script from "./gaokaobaike_mobile.vue?vue&type=script&lang=js"
export * from "./gaokaobaike_mobile.vue?vue&type=script&lang=js"
import style0 from "./gaokaobaike_mobile.vue?vue&type=style&index=0&id=6ff0123f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0123f",
  null
  
)

export default component.exports